module.exports = __webpack_public_path__ + "static/bo-426c0d64597047ce596fa5bf50a25d98.svg";